import Checkbox from "../../input/Checkbox";
import UnorderedList from "../../structure/UnorderedList";
import { DisabilityEmployeeFormValues } from "../../disability/DisabilityEmployeeFormValues";
import QuestionPanel from "../../structure/QuestionPanel";
import React from "react";
import { BenefitType } from "../../enums/BenefitType";
import { OtherBenefitType } from "../../enums/OtherBenefitType";
import { useFormikContext } from "formik";

function OtherBenefits() {
    const { values } = useFormikContext<DisabilityEmployeeFormValues>();
    const benefit = values.benefit;

    return (
        <QuestionPanel headerText="Are you receiving benefits from any of the following sources?"
                       panelContent={<>
                           <Checkbox id="other-benefits"
                                     label="Yes, I am receiving or have applied for at least one of the following:"/>
                           <div className="pds-u-padding-left-20">
                               <UnorderedList id="benefit-types"
                                              elements={findOtherBenefitTypesFor(benefit)}/>
                           </div>
                           <Checkbox id="other-disability-insurer"
                                     label="I have disability insurance from another insurance company"/>
                           <h5 id="click-next">If none, click Next.</h5>
                           {(values.otherBenefits || values.otherDisabilityInsurer)
                           && <div id="other-benefits-communication" className="pds-u-padding-bottom-16">
                               After your claim submission, you will receive additional communication from
                               Principal asking for details regarding your additional income.
                               Please have the following information available: the type(s) of income, the
                               date the income(s) began, and the income amount(s).
                           </div>}
                       </>}
        >
        </QuestionPanel>
    );
}

function findOtherBenefitTypesFor(benefit: BenefitType) {
    if (BenefitType.PAID_FAMILY_AND_MEDICAL_LEAVE === benefit) {
        return [
            OtherBenefitType.SOCIAL_SECURITY_DISABILITY,
            OtherBenefitType.UNEMPLOYMENT,
            OtherBenefitType.WORKERS_COMPENSATION
        ];
    } else if (BenefitType.DISABILITY === benefit) {
        return [
            OtherBenefitType.PENSION,
            OtherBenefitType.SOCIAL_SECURITY_DISABILITY,
            OtherBenefitType.SOCIAL_SECURITY_EARLY_RETIREMENT,
            OtherBenefitType.SOCIAL_SECURITY_RETIREMENT,
            OtherBenefitType.SOCIAL_SECURITY_WIDOWS,
            OtherBenefitType.STATE_DISABILITY,
            OtherBenefitType.WORKERS_COMPENSATION
        ];
    }
    return [];
}

export default OtherBenefits;